// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import {
  FulfillmentOrder,
  fulfillmentOrderSchema,
} from '@/fulfillment/api/types';
import { z } from 'zod';

/**
 * Schema for validating the response from the close fulfillment order API endpoint.
 */
const closeFulfillmentOrderResponseSchema = z.object({
  data: fulfillmentOrderSchema,
  metadata: responseMetadataSchema,
});

/**
 * Closes an existing fulfillment order for reporting.
 *
 * @param fulfillmentKey - The key of the fulfillment order to close
 * @returns The closed fulfillment order
 */
export async function closeFulfillmentOrder(
  fulfillmentKey: string
): Promise<FulfillmentOrder> {
  const url = `/v1/fulfillment/${fulfillmentKey}/close`;
  const response = await api.post(url, {});

  const { data } = await parseResponse(
    closeFulfillmentOrderResponseSchema,
    response.data,
    {
      schemaName: 'CloseFulfillmentOrder',
      endpoint: url,
    }
  );
  return data;
}
